import { API_BASE_URL } from "src/config/apiBase";
import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { countries } from '../Country';
import { indianStates } from '../IndianStates';
//import { Link } from 'react-router-dom';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomerContactEdit from './CustomerContactEdit';
import { useSidebar } from '../../SidebarContext';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import normalizePhoneNumber from '../utils/normalizePhoneNumber';
import { toast } from 'react-toastify';
import { decryptToken } from '../utils/getToken';


const AddCustomer3 = () => {
    
    const [selectedType, setSelectedType] = useState('individual');
    const [activeTab, setActiveTab] = useState(1);
    const [isMoreDetailsOpen, setMoreDetailsOpen] = useState(false);

    const location = useLocation();
    const submittedData = location.state;
    const url = API_BASE_URL

    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    const handleTabClick = (tabIndex) => setActiveTab(tabIndex);
    const toggleMoreDetails = () => setMoreDetailsOpen(!isMoreDetailsOpen);
    const [contactList, setContactList] = useState([]);
    const token = decryptToken("accessToken") || ""
    const [formData, setFormData] = useState({
        customerName: "",
        companyName: "",
        displayName: "",
        email: "",
        phone1: "",
        phone2: "",
        gstNumber: "",
        placeOfSupply: "",
        pan: "",
        currency: "INR",
        remarks: "",
        billingAddress: {
            attention: "",
            country: "",
            address: "",
            city: "",
            state: "",
            pincode: "",
            number: "",
        },
        shippingAddress: {
            attention: "",
            country: "",
            address: "",
            city: "",
            state: "",
            pincode: "",
            number: "",
        },
        website_url: "",
        department: "",
        designation: "",
        twitter: "",
        skype: "",
        facebook: "",
        user_id: isLoggedIn.main_id,
        user_name: isLoggedIn.full_name,
        sales_person: "",
        sales_ID: ""

    });

    // const [document, setDocument] = useState(null);
    // const [documentPreview, setDocumentPreview] = useState('');
    const navigate = useNavigate();
    const [document, setDocument] = useState(null);
    const [documentPreview, setDocumentPreview] = useState(null);
    const [documentType, setDocumentType] = useState("");


    const handleFileChange = (e) => {
        const file = e.target.files[0];

        if (file) {
            const allowedTypes = /(\.jpeg|\.jpg|\.png|\.webp|\.pdf)$/i;

            if (!allowedTypes.test(file.name)) {
                alert("Only JPEG, JPG, PNG, WEBP, and PDF files are allowed.");
                e.target.value = null; // Clear file input
                setDocument(null);
                setDocumentPreview(null);
                setDocumentType("");
                return;
            }

            setDocument(file);
            setDocumentType(file.type);

            // For images and PDFs
            const previewURL = URL.createObjectURL(file);
            setDocumentPreview(previewURL);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === "phone1" || name === "phone2") {
            const normalized = normalizePhoneNumber(value);
            setFormData(prev => ({ ...prev, [name]: normalized }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }

    };

    const handleSelectChange = (selected, { name }) => {
        setFormData(prev => ({ ...prev, [name]: selected ? selected.value : "" }));
    };

    // const [billingAddress, setBillingAddress] = useState({
    //     attention: "",
    //     country: "",
    //     address: "",
    //     city: "",
    //     state: "",
    //     pincode: "",
    //     number: "",
    // });

    // const [shippingAddress, setShippingAddress] = useState({
    //     attention: "",
    //     country: "",
    //     address: "",
    //     city: "",
    //     state: "",
    //     pincode: "",
    //     number: "",
    // });

    const handleBillingChange = (e) => {
        const { name, value } = e.target;
        const processedValue = name === "number" ? normalizePhoneNumber(value) : value;
        setFormData(prev => ({
            ...prev,
            billingAddress: {
                ...prev.billingAddress,
                [name]: processedValue,
            }
        }));
    };

    const handleShippingChange = (e) => {
        const { name, value } = e.target;
        const processedValue = name === "number" ? normalizePhoneNumber(value) : value;

        setFormData(prev => ({
            ...prev,
            shippingAddress: {
                ...prev.shippingAddress,
                [name]: processedValue,
            }
        }));
    };

    const handleBillingSelectChange = (selected, { name }) => {
        setFormData(prev => ({
            ...prev,
            billingAddress: {
                ...prev.billingAddress,
                [name]: selected ? selected.value : "",
            }
        }));
    };

    const handleShippingSelectChange = (selected, { name }) => {
        setFormData(prev => ({
            ...prev,
            shippingAddress: {
                ...prev.shippingAddress,
                [name]: selected ? selected.value : "",
            }
        }));
    };


    const copyBillingToShipping = () => {
        setFormData(prev => ({
            ...prev,
            shippingAddress: { ...prev.billingAddress }
        }));
    };


    const currencyOptions = [
        { value: 'INR', label: 'INR' },
    ];
    const handleSubmit = async (e) => {
        e.preventDefault();

        const formDataToSend = new FormData();

        // Convert address and contact to JSON strings
        formDataToSend.append("billingAddress", JSON.stringify(formData.billingAddress));
        formDataToSend.append("shippingAddress", JSON.stringify(formData.shippingAddress));
        formDataToSend.append("contact", JSON.stringify(contactList));

        // Append other fields
        formDataToSend.append("customerName", formData.customerName);
        formDataToSend.append("companyName", formData.companyName);
        formDataToSend.append("displayName", formData.displayName);
        formDataToSend.append("email", formData.email);
        formDataToSend.append("phone1", formData.phone1);
        formDataToSend.append("phone2", formData.phone2);
        formDataToSend.append("gstNumber", formData.gstNumber);
        formDataToSend.append("placeOfSupply", formData.placeOfSupply);
        formDataToSend.append("pan", formData.pan);
        formDataToSend.append("currency", formData.currency);
        formDataToSend.append("remarks", formData.remarks);
        formDataToSend.append("website_url", formData.website_url);
        formDataToSend.append("department", formData.department);
        formDataToSend.append("designation", formData.designation);
        formDataToSend.append("twitter", formData.twitter);
        formDataToSend.append("skype", formData.skype);
        formDataToSend.append("facebook", formData.facebook);
        formDataToSend.append("customerType", selectedType);
        formDataToSend.append("user_id", isLoggedIn.main_id)
        formDataToSend.append("user_name", isLoggedIn.full_name)
        formDataToSend.append("sales_person", formData.sales_person)
        formDataToSend.append("sales_ID", formData.sales_ID)

        // Optional: If image is selected
        if (document) {
            formDataToSend.append("document", document);
        }


        const method = formData.id ? "PUT" : "POST";
        const urlmain = formData.id
            ? `${url}/api/customer/${formData.id}`
            : `${url}/api/customer/`;

        try {
            const res = await fetch(urlmain, {
                method,
                body: formDataToSend,
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });

            const result = await res.json();
            if (res.ok) {
                toast.success(`Customer ${formData.id ? "updated" : "created"} successfully!`);
                navigate("/customer"); // Redirect to customer list or desired page
            } else {
                toast.error(result.message || "Failed to submit");
            }
        } catch (err) {
            toast.error(err);
        }
    };



    // const handleDelete = async (customerId) => {

    //     const confirm = window.confirm('Are you sure you want to delete this customer?');
    //     if (!confirm) return;

    //     try {
    //       const response = await fetch(`http://192.168.1.47:5000/api/customers/${customerId}`, {
    //         method: 'DELETE',
    //       });

    //       if (!response.ok) {
    //         const err = await response.json();
    //         throw new Error(err?.message || 'Failed to delete');
    //       }

    //       alert('Customer deleted successfully!');
    //       // Optional: redirect to customer list or clear form
    //     } catch (error) {
    //       console.error('Delete error:', error.message);
    //       alert(`Error: ${error.message}`);
    //     }
    //   };

    useEffect(() => {
        if (submittedData) {
            setFormData(submittedData);
            setContactList(submittedData.contact || []);
            if (submittedData.document) {
                const fullUrl = `${url}/${submittedData.document}`;
                setDocumentPreview(fullUrl);

                // Set type based on file extension
                const ext = submittedData.document.split(".").pop().toLowerCase();
                if (ext === "pdf") {
                    setDocumentType("application/pdf");
                } else if (["jpg", "jpeg", "png", "webp"].includes(ext)) {
                    setDocumentType("image");
                } else {
                    setDocumentType(null);
                }
            }
        }
    }, [submittedData]);



    return (
        <>
            <form className="oms-modal-form" onSubmit={handleSubmit}>
                <div className="oms-form-group">
                    <label className="oms-form-label">Customer Type</label>
                    <div className="oms-form-radio">
                        <label
                            className={`radio-label ${selectedType === 'individual' ? 'checked' : ''}`}
                        >
                            <input
                                type="radio"
                                name="customerType"
                                value="individual"
                                checked={selectedType === 'individual'}
                                onChange={() => setSelectedType('individual')}
                            />
                            Individual
                        </label>
                        <label
                            className={`radio-label ${selectedType === 'company' ? 'checked' : ''}`}
                        >
                            <input
                                type="radio"
                                name="customerType"
                                value="company"
                                checked={selectedType === 'company'}
                                onChange={() => setSelectedType('company')}
                            />
                            Company
                        </label>
                    </div>
                </div>
                <div className="oms-form-flex">
                    <div className="oms-form-group">
                        <label htmlFor="customerName" className="oms-form-label">
                            Customer Name
                        </label>
                        <input
                            type="text"
                            id="customerName"
                            name="customerName"
                            value={formData.customerName}
                            onChange={handleInputChange}
                            placeholder="Enter customer name"
                        />
                    </div>


                    <div className="oms-form-group">
                        <label htmlFor="companyName" className="oms-form-label">
                            Company Name
                        </label>
                        <input type="text" id="companyName"
                            name="companyName"
                            value={formData.companyName}
                            onChange={handleInputChange}
                            placeholder="Enter company name" />
                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="displayName" className="oms-form-label">
                            Display Name
                        </label>
                        <input type="text"
                            name="displayName"
                            value={formData.displayName}

                            onChange={handleInputChange}
                            placeholder="Enter display name" />
                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="currency" className="oms-form-label">
                            Currency
                        </label>
                        <Select
                            name="currency"
                            value={formData.currency ? { value: formData.currency, label: formData.currency } : null}
                            options={currencyOptions}
                            onChange={handleSelectChange}
                            isDisabled
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="email" className="oms-form-label">
                            Email
                        </label>
                        <input type="email" id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            placeholder="Enter email" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="phone1" className="oms-form-label">
                            Phone Number 1
                        </label>
                        <input type="tel" id="phone1"
                            name="phone1"
                            value={formData.phone1}
                            onChange={handleInputChange}
                            onKeyPress={(e) => {
                                if (!/[0-9]/.test(e.key)) {
                                    e.preventDefault(); // Prevent non-numeric characters
                                }
                            }}
                            placeholder="Enter phone number 1" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="phone2" className="oms-form-label">
                            Phone Number 2
                        </label>
                        <input type="tel" id="phone2"
                            name="phone2"
                            value={formData.phone2}
                            onChange={handleInputChange}
                            onKeyPress={(e) => {
                                if (!/[0-9]/.test(e.key)) {
                                    e.preventDefault(); // Prevent non-numeric characters
                                }
                            }}
                            placeholder="Enter phone number 2" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="sales_person" className="oms-form-label">
                            Sales Person Name / ID
                        </label>
                        <input type="text" id="sales_person"
                            name="sales_person"
                            value={formData.sales_person}
                            onChange={handleInputChange}
                            placeholder="Enter Sales Person Name or Id" />
                    </div>


                </div>


                {/* Tabs */}
                <div className="customer-form-tab">
                    <ul className="tab-list">
                        <li
                            className={`tab ${activeTab === 1 ? 'active' : ''}`}
                            onClick={() => handleTabClick(1)}
                        >
                            Other Details
                        </li>
                        <li
                            className={`tab ${activeTab === 2 ? 'active' : ''}`}
                            onClick={() => handleTabClick(2)}
                        >
                            Address
                        </li>
                        <li
                            className={`tab ${activeTab === 3 ? 'active' : ''}`}
                            onClick={() => handleTabClick(3)}
                        >
                            Contact
                        </li>
                        <li
                            className={`tab ${activeTab === 4 ? 'active' : ''}`}
                            onClick={() => handleTabClick(4)}
                        >
                            Remarks
                        </li>
                    </ul>

                    {/* Tab Content */}
                    <div className="tab-content">
                        {activeTab === 1 && (
                            <div className="tab-block">
                                <div className="oms-form-flex">
                                    <div className="oms-form-group">
                                        <label htmlFor="number" className="oms-form-label">
                                            GST Number
                                        </label>
                                        <input
                                            type="text"
                                            id="gstNumber"
                                            name="gstNumber"
                                            value={formData.gstNumber}
                                            onChange={handleInputChange}
                                            placeholder="Enter your GST number"
                                        />
                                    </div>
                                    <div className="oms-form-group">
                                        <label htmlFor="name" className="oms-form-label">
                                            Place of supply
                                        </label>
                                        <Select
                                            name="placeOfSupply"
                                            value={formData.placeOfSupply ? { value: formData.placeOfSupply, label: formData.placeOfSupply } : null}
                                            options={indianStates.map((state) => ({ value: state.name, label: state.name }))}
                                            onChange={handleSelectChange}
                                            placeholder="Select state"
                                            isClearable
                                        />
                                    </div>
                                    <div className="oms-form-group">
                                        <label htmlFor="pan" className="oms-form-label">Pan</label>
                                        <input
                                            type="text"
                                            id="pan"
                                            name="pan"
                                            value={formData.pan}
                                            onChange={handleInputChange}
                                            placeholder="Enter your PAN number"
                                        />
                                    </div>
                                </div>
                                <div className="oms-form-group">
                                    <label htmlFor="file" className="oms-form-label">
                                        Documents
                                    </label>
                                    <label htmlFor="file" className="oms-form-upload">
                                        <i className="fa-solid fa-arrow-up-from-bracket"></i> Upload File
                                        <input type="file" id="file" name="file" className="file-input" onChange={handleFileChange} />
                                    </label>
                                </div>
                                {documentPreview && (
                                    <>
                                        {documentType === "application/pdf" ? (
                                            <a href={documentPreview} target="_blank" rel="noopener noreferrer">
                                                <embed
                                                    src={documentPreview}
                                                    type="application/pdf"
                                                    width="100px"
                                                    height="140px"
                                                    style={{ marginTop: '10px' }}
                                                />
                                            </a>
                                        ) : (
                                            <a href={documentPreview} target="_blank" rel="noopener noreferrer">
                                                <img
                                                    src={documentPreview}
                                                    alt="Document Preview"
                                                    style={{ width: '100px', marginTop: '10px' }}
                                                />
                                            </a>
                                        )}
                                    </>
                                )}


                                <p className="oms-add-more-details-link" onClick={toggleMoreDetails}>
                                    Add more details
                                </p>
                                {isMoreDetailsOpen && (
                                    <div className="oms-add-more-details-section">
                                        <div className="oms-form-flex">
                                            <div className="oms-form-group">
                                                <label htmlFor="text" className="oms-form-label" >
                                                    Website URL
                                                </label>
                                                <input type="text" placeholder="Enter your Website URL" name='website_url' value={formData.website_url} onChange={handleInputChange} />
                                            </div>
                                            <div className="oms-form-group">
                                                <label htmlFor="text" className="oms-form-label" >
                                                    Department
                                                </label>
                                                <input type="text" placeholder="Enter your department" name='department' value={formData.department} onChange={handleInputChange} />
                                            </div>
                                            <div className="oms-form-group">
                                                <label htmlFor="text" className="oms-form-label">
                                                    Designation
                                                </label>
                                                <input type="text" placeholder="Enter your designation" name='designation' value={formData.designation} onChange={handleInputChange} />
                                            </div>
                                            <div className="oms-form-group">
                                                <label htmlFor="text" className="oms-form-label">
                                                    Twitter
                                                </label>
                                                <div className="oms-form-with-icon">
                                                    <input type="text" placeholder="Enter your twitter URL" name='twitter' value={formData.twitter} onChange={handleInputChange} />
                                                </div>
                                            </div>
                                            <div className="oms-form-group">
                                                <label htmlFor="text" className="oms-form-label">
                                                    Skype
                                                </label>
                                                <div className="oms-form-with-icon">
                                                    <input type="text" placeholder="Enter your skype URL" name='skype' value={formData.skype} onChange={handleInputChange} />
                                                </div>
                                            </div>
                                            <div className="oms-form-group">
                                                <label htmlFor="text" className="oms-form-label">
                                                    Facebook
                                                </label>
                                                <div className="oms-form-with-icon">
                                                    <input type="text" placeholder="Enter your facebook URL" name='facebook' value={formData.facebook} onChange={handleInputChange} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                        {activeTab === 2 && (
                            <div className="tab-block">
                                <div className="oms-address-section">
                                    {/* Billing Address */}
                                    <div className="oms-billing-address">
                                        <div className="oms-address-heading">Billing address</div>

                                        <div className="oms-form-group">
                                            <label className="oms-form-label">Attention</label>
                                            <input
                                                type="text"
                                                name="attention"
                                                value={formData.billingAddress.attention}
                                                onChange={handleBillingChange}
                                                placeholder="Enter Your Attention"
                                            />
                                        </div>

                                        <div className="oms-form-group">
                                            <label className="oms-form-label">Country/Region</label>
                                            <Select
                                                name="country"
                                                value={formData.billingAddress.country ? { value: formData.billingAddress.country, label: formData.billingAddress.country } : null}
                                                options={countries.map((country) => ({ value: country.name, label: country.name }))}
                                                onChange={handleBillingSelectChange}
                                                placeholder="Select an option"
                                                isClearable
                                            />
                                        </div>

                                        <div className="oms-form-group">
                                            <label className="oms-form-label">Address</label>
                                            <textarea
                                                name="address"
                                                placeholder="Street 1"
                                                value={formData.billingAddress.address}
                                                onChange={handleBillingChange}
                                                required
                                            />
                                        </div>

                                        <div className="oms-form-group">
                                            <label className="oms-form-label">City</label>
                                            <input
                                                type="text"
                                                name="city"
                                                placeholder="Enter Your City"
                                                value={formData.billingAddress.city}
                                                onChange={handleBillingChange}
                                                required
                                            />
                                        </div>

                                        <div className="oms-form-group">
                                            <label className="oms-form-label">State</label>
                                            <Select
                                                name="state"
                                                value={formData.billingAddress.state ? { value: formData.billingAddress.state, label: formData.billingAddress.state } : null}
                                                options={indianStates.map((state) => ({ value: state.name, label: state.name }))}
                                                onChange={handleBillingSelectChange}
                                                placeholder="Select an option"
                                                isClearable
                                            />
                                        </div>

                                        <div className="oms-form-group">
                                            <label className="oms-form-label">Pincode</label>
                                            <input
                                                type="number"
                                                name="pincode"
                                                placeholder="Enter Your Pincode"
                                                value={formData.billingAddress.pincode}
                                                onChange={handleBillingChange}
                                                required
                                            />
                                        </div>

                                        <div className="oms-form-group">
                                            <label className="oms-form-label">Phone Number</label>
                                            <input
                                                type="tel"
                                                name="number"
                                                placeholder="Enter Your Number"
                                                value={formData.billingAddress.number}
                                                onChange={handleBillingChange}
                                                onKeyPress={(e) => {
                                                    if (!/[0-9]/.test(e.key)) {
                                                        e.preventDefault(); // Prevent non-numeric characters
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>

                                    {/* Shipping Address */}
                                    <div className="oms-shipping-address">
                                        <div className="oms-address-heading">
                                            Shipping Address{" "}
                                            <span onClick={copyBillingToShipping}>
                                                ( <i className="fa-regular fa-clipboard"></i> same as billing )
                                            </span>
                                        </div>

                                        <div className="oms-form-group">
                                            <label className="oms-form-label">Attention</label>
                                            <input
                                                type="text"
                                                name="attention"
                                                placeholder="Enter Your Attention"
                                                value={formData.shippingAddress.attention}
                                                onChange={handleShippingChange}
                                            />
                                        </div>

                                        <div className="oms-form-group">
                                            <label className="oms-form-label">Country/Region</label>
                                            <Select
                                                name="country"
                                                value={formData.shippingAddress.country ? { value: formData.shippingAddress.country, label: formData.shippingAddress.country } : null}
                                                options={countries.map((country) => ({ value: country.name, label: country.name }))}
                                                onChange={handleShippingSelectChange}
                                                placeholder="Select an option"
                                                isClearable
                                            />
                                        </div>

                                        <div className="oms-form-group">
                                            <label className="oms-form-label">Address</label>
                                            <textarea
                                                name="address"
                                                placeholder="Street 1"
                                                value={formData.shippingAddress.address}
                                                onChange={handleShippingChange}
                                                required
                                            />
                                        </div>

                                        <div className="oms-form-group">
                                            <label className="oms-form-label">City</label>
                                            <input
                                                type="text"
                                                name="city"
                                                placeholder="Enter Your City"
                                                value={formData.shippingAddress.city}
                                                onChange={handleShippingChange}
                                                required
                                            />
                                        </div>

                                        <div className="oms-form-group">
                                            <label className="oms-form-label">State</label>
                                            <Select
                                                name="state"
                                                value={formData.shippingAddress.state ? { value: formData.shippingAddress.state, label: formData.shippingAddress.state } : null}
                                                options={indianStates.map((state) => ({ value: state.name, label: state.name }))}
                                                onChange={handleShippingSelectChange}
                                                placeholder="Select an option"
                                                isClearable
                                            />
                                        </div>

                                        <div className="oms-form-group">
                                            <label className="oms-form-label">Pincode</label>
                                            <input
                                                type="number"
                                                name="pincode"
                                                placeholder="Enter Your Pincode"
                                                value={formData.shippingAddress.pincode}
                                                onChange={handleShippingChange}
                                                required
                                            />
                                        </div>

                                        <div className="oms-form-group">
                                            <label className="oms-form-label">Phone Number</label>
                                            <input
                                                type="tel"
                                                name="number"
                                                placeholder="Enter Your Number"
                                                value={formData.shippingAddress.number}
                                                onChange={handleShippingChange}
                                                onKeyPress={(e) => {
                                                    if (!/[0-9]/.test(e.key)) {
                                                        e.preventDefault(); // Prevent non-numeric characters
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {activeTab === 3 && (
                            <div className="tab-block">
                                <CustomerContactEdit contacts={contactList}
                                    setContacts={setContactList}
                                />
                            </div>
                        )}
                        {activeTab === 4 && (
                            <div className="tab-block">
                                <div className="oms-form-group">
                                    <label for="remarks" className="oms-form-label">Remark:</label>
                                    <textarea id="remarks" name="remarks"
                                        value={formData.remarks}
                                        onChange={handleInputChange}
                                        rows="4" placeholder="Additional comments or preferences"></textarea>
                                </div>
                            </div>
                        )}
                    </div>
                </div>



                <div className="oms-form-actions">

                    {/* //<Link to="/add-customer2">
          <button type="button">Back</button>
       {/* </Link>
                <button type="button" onClick={() => handleDelete(formData.id)}>Delete</button> */}

                    <button type="submit"
                    >Update</button>
                </div>
            </form>
        </>
    );
};

export default AddCustomer3;
